import styled from 'styled-components';
import Race from '../../../components/fields/RaceField';
import { type Brightness } from '../../context';
import { PorscheSelectCss } from './shared';
import withPorscheSelect from './withPorscheSelect';

const PorscheRaceField = styled(Race)<Brightness>`
    ${PorscheSelectCss}
`;

const RaceField = withPorscheSelect(PorscheRaceField);
export default RaceField;
